import {Component, Input, OnInit} from '@angular/core';
import {ModalService} from "../../services/modalService";
import {BookingService} from "../../services/booking.service";
import {AppUtilityService} from "../../services/AppUtilityService";

@Component({
  selector: 'app-track-error',
  templateUrl: './tracking-error-modal.component.html',
  styleUrls: ['./tracking-error-modal.component.css']
})
export class TrackErrorComponent implements OnInit {

  trackingEvents: any = [];
  booking: any;
  trackNo: string = '';

  constructor(public modalService: ModalService, private appUtil: AppUtilityService,private bookingService: BookingService) {}

  ngOnInit(): void {
   
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

  openModal(): void {
    if (this.trackNo != '') {
      this.modalService.closeModal();
      this.bookingService.trackbooking(this.trackNo).subscribe(
        (response :any)=> {
          
          this.appUtil.loaderService().removeLoader();
          if (response.error) {
            this.appUtil.errorService().showErrorToast(response.error.message);
          } else {
            if (response.trackingInfo === null) {
              this.appUtil.errorService().showErrorToast("Track number " + this.trackNo + ' is invalid.');
              this.trackNo = '';
            } else {
              this.appUtil.persistenceService().set('trackingData', response);
              this.modalService.openTrackBookingModal({trackNo: this.trackNo});
              this.trackNo = '';
            }
          }
        }
      );
    } else {
      this.appUtil.errorService().showErrorToast("Enter a track number.");
    }
  }
}
